module.exports = __webpack_public_path__ + "static/media/dundalk.16c777c3.png";